var now,distance,days,hours,minutes,seconds,interval,prodDropDate,interval1,interval2;
var x=0;
var comingsoonend,getBtn,getUpsellcontent,getTermscondition;
var timerElement; // plp comingsoon state : if liquid date field cached, window refresh happens continuosly through timerjs. couldnt set session storage to support multiple comingsoon product scenarios

$(document).ready(function () {
	const uA = navigator.userAgent;
	const vendor = navigator.vendor;
	/*if (
		/Safari/i.test(uA) &&
		/Apple Computer/.test(vendor) &&
		!/Mobi|Android/i.test(uA)
	) */

	timmerS();
	timmerHandle();

	// handles the timer on PDP for Raffle Products
	timerSDG();
});

function aspotScenario(thisE){
	var asopW = thisE.parents('.a-spot-regular').parent();
	  var productType = asopW.find("#product_type_special").val();
	  var stockstatus = asopW.find("#stockstatus").val();
	  var datep = new Date().getTime();
	  var comingSW = asopW.find("#comingSoondate");
	  var preoW = asopW.find("#preOrderDate");
	  if(productType === 'true'){

		if(comingSW.length > 0){
		  var comingSWV = new Date(comingSW.val()).getTime();

		  if(datep>comingSWV || datep>preoWV){
			if(stockstatus == 'outstock'){
			  asopW.find('.spot-add-button-wrap').addClass('hide');
			  asopW.find('.sold-out-btn-wrap').removeClass('hide');
			  asopW.find('.soldout-redirect').removeClass('hide');
			  asopW.find('.addto-redirect').addClass('hide');
			}
			else{
			  asopW.find('.spot-add-button-wrap').removeClass('hide');
			  asopW.find('.sold-out-btn-wrap').addClass('hide');
			  asopW.find('.soldout-redirect').addClass('hide');
			  asopW.find('.addto-redirect').removeClass('hide');
			}
		  }
		  else{

			asopW.find('.spot-add-button-wrap').removeClass('hide');
			asopW.find('.sold-out-btn-wrap').addClass('hide');
			asopW.find('.soldout-redirect').addClass('hide');
			asopW.find('.addto-redirect').removeClass('hide');
		  }

		}
		else if(preoW.length > 0){
		  var preoDval = preoW.val();
		  var preoWV = new Date(preoDval).getTime();

		  if(datep>preoWV){
			if(stockstatus == 'outstock'){
			  asopW.find('.spot-add-button-wrap').addClass('hide');
			  asopW.find('.sold-out-btn-wrap').removeClass('hide');
			  asopW.find('.soldout-redirect').removeClass('hide');
			  asopW.find('.addto-redirect').addClass('hide');
			}
			else{
			  asopW.find('.spot-add-button-wrap').removeClass('hide');
			  asopW.find('.sold-out-btn-wrap').addClass('hide');
			  asopW.find('.soldout-redirect').addClass('hide');
			  asopW.find('.addto-redirect').removeClass('hide');
			  var addBtnText = $("#btnTextActual").val();
			  asopW.find('.spot-add-button-wrap').find('.addtocartBtn-aspot').text(addBtnText);
			}

		  }
		  else{
			  asopW.find('.spot-add-button-wrap').removeClass('hide');
			  asopW.find('.sold-out-btn-wrap').addClass('hide');
			  asopW.find('.soldout-redirect').addClass('hide');
			  asopW.find('.addto-redirect').removeClass('hide');
			  var addBtnText = $("#aspot-buttonText").val();
			  asopW.find('.spot-add-button-wrap').find('.addtocartBtn-aspot').text(addBtnText);
		  }
		}
	  }

	  else{
		if(stockstatus == 'outstock'){
		  asopW.find('.spot-add-button-wrap').addClass('hide');
		  asopW.find('.sold-out-btn-wrap').removeClass('hide');
		  asopW.find('.soldout-redirect').removeClass('hide');
		  asopW.find('.addto-redirect').addClass('hide');
		}
		else{
		  asopW.find('.spot-add-button-wrap').removeClass('hide');
		  asopW.find('.sold-out-btn-wrap').addClass('hide');
		  asopW.find('.soldout-redirect').addClass('hide');
		  asopW.find('.addto-redirect').removeClass('hide');
		}
	  }
	  asopW.find('.hidebeforeload').removeClass('hide');


}

var countervariables=[],expiredtimer=[];
function timmerS(){
  var counter,counters=0,getParent;
  $('.timerDate').each(function(){
    expiredtimerobj={};
    counterobj={};
    counters++;
    counter=counters;
    var self=$(this);
		prodDropDate=self.val();
    var timerSelector=self.closest('.sale-module').addClass('timer'+counter);
    if(prodDropDate == "timerReached"){
      expiredtimerobj['selector']=timerSelector;
      expiredtimerobj['element']=self;
      expiredtimer.push(expiredtimerobj);
    } else if (typeof prodDropDate !== "undefined") {
      if (prodDropDate != "Enter Drop date in above format") {
        //displayTimer(prodDropDate,getParent);
        var countDownDate = new Date(prodDropDate).getTime();
        counterobj['date']=countDownDate;
        counterobj['selector']=timerSelector;
        counterobj['element']=self;
        counterobj['fullDate']=prodDropDate;
        countervariables.push(counterobj);
      }
    }
	});

  for(var i=0;i<countervariables.length;i++){
    timerShow(countervariables[i].date,countervariables[i].selector,countervariables[i].element);

  }
    for(var i=0;i<expiredtimer.length;i++){
		//expiredTimershowState(expiredtimerobj[i].selector,expiredtimerobj[i].element);
        displayTimerinfo("salestarted",expiredtimer[i].element.parents('.sale-module'));
	}
  setInterval(function() {
    $.each(countervariables, function(i, obj) {
    	//interval=timerShow(countervariables[i].date,countervariables[i].selector,countervariables[i].element);
      now = new Date().getTime();
      distance = countervariables[i].date - now;
      var self = countervariables[i].element;
      timerElement = 'plptimer'+self.parents('.sale-module').attr('class').split('timer')[1].split(' ')[0];
      var modD = self.parents('.sale-module');
      modD.removeClass('hide');
      if (distance < 0) {
      	clearInterval();
        if($('.template-collection')[0] && $('.plp-coming-soon')[0]){
          if (!sessionStorage.getItem(timerElement)) {
            sessionStorage.setItem(timerElement, "true");
            window.location.reload();
          }
          self.parents('.product-item ').find('.product-item__info .comingsoon').hide();
          self.parents('.product-item ').find('.product-item__info .showSoldout').show();
        } else if($('.template-product')[0] && $('.pdp-coming-soon')[0]) {
          if (!sessionStorage.pdpSession) {
            sessionStorage.setItem("pdpSession", "true");
            window.location.reload();
          }
          setTimeout(function(){
            $('.coming-soon-badge').hide();
            $('.pre-order-msg').remove();

            if($('.comingsoon-preorder')[0]){
              $('.product__payment-container.comingsoon-preorder').css('display','block');
            }

            if ($('.comingsoon-upsell')[0]) {
              $('.upsell-container.comingsoon-upsell').css('display','block');
              $('.tnc-container.comingsoon-upsell').addClass('showtnc');
            }
            $('.product__payment-container .comingsoonends').addClass('black-bg-cta').css('display','block');
            if($('#signupNeeded').val()== 'false'){ //product available
              $('.pdp-soldout').remove();
              $('.soldout-badge').remove();
            } else {
              $('.soldout-badge').remove();
              var soldoutElem ='<span class="prd-inventory-tag color-gray addtitional-meta-fields medium soldout-badge" style="padding-left:0">Sold Out</span>';
              $(soldoutElem).insertBefore('.product__meta .product__vendor');
              $('.product__add-to-cart').text("Sold Out"); // making text as soldout for soldout cases (js fixes for date caching issue)
              $('.ship-available-date').closest('.grid').hide(); // hiding shipping info for soldout cases
            }
          },500);
        }

				else{
					if (!sessionStorage.justOnce) {
						sessionStorage.setItem("justOnce", "true");
					}
			    }
				modD.find('.sale--live').hide().find('.learn-more').hide().find('.timer-container').hide();
				modD.find('.sale-date').hide();
				modD.find('.shop-now-btn').show();
				/*Waiting Room */
				if($('.waiting-room')[0]){
					$('.sale-live-container,.related-products').show();
				  $('.presale-container,.sale-module .module__text').hide();
				}

				$('.timer-display').css({'padding-right':'24px'});
				displayTimerinfo("salestarted",modD);

				var mainT = countervariables[i].element.parents('.content-inside');
				if(mainT.find('.addtocartBtn').length > 0){
					mainT.find('.launching-info .sale-live-text').removeClass('hide');
					mainT.find('.launching-info  .lauching-date').addClass('hide');
					mainT.find('.addtocartBtn').removeClass('hide');
					mainT.find('.learnmoreBtn').addClass('hide');
				}

				if(modD.parents('.flex-grid-wrapper').length > 0){
					if(modD.hasClass('no-reload') == false){
						location.reload();
					}
				}

				aspotScenario(self);

			}
			else{

				 // Time calculations for days, hours, minutes and seconds
				 days = Math.floor(distance / (1000 * 60 * 60 * 24));
				 hours = Math.floor(
					 (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
				 );
				 minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
				 seconds = Math.floor((distance % (1000 * 60)) / 1000);

				// increase hour count by 1 if Daylight Savings is Active for the users locale date

				 // Output the result in an element with id="demo"
				 countervariables[i].selector.find(".days").text(("0" + days).slice(-2));
				 countervariables[i].selector.find(".hours").text(("0" + hours).slice(-2));
				 countervariables[i].selector.find(".minutes").text(("0" + minutes).slice(-2));
				 countervariables[i].selector.find(".seconds").text(("0" + seconds).slice(-2));
				 if($('.template-product')[0] && $('.pdp-coming-soon')[0]){
					$('.coming-soon-badge,.pre-order-msg').css('display','inline-block');
				 }
                 if($('.template-collection')[0] && $('.plp-coming-soon')[0]){
                    self.parents('.product-item ').find('.product-item__info .comingsoon').show();
				}
				 if(days==0){

					$('.plp-button').show().css('margin-right','30px');
					$('.sale-live-container').hide();
					modD.find('.sale--live').show();
					modD.find('.learn-more').show();
					modD.find('.timer-container').show();
					modD.find('.module__text').show();
					displayTimerinfo("salenotstarted",modD);
				}
				else {

					var mainT = countervariables[i].element.parents('.content-inside');
					if(mainT.find('.addtocartBtn').length > 0){
							mainT.find('.launching-info .sale-live-text').addClass('hide');
						mainT.find('.launching-info  .lauching-date').removeClass('hide');
						mainT.find('.addtocartBtn').addClass('hide');
						mainT.find('.learnmoreBtn').removeClass('hide');
					}

					modD.find('.sale--live').show();
					modD.find('.learn-more').show();
					modD.find('.timer-container').show();

					if($('.waiting-room')[0]){
						$('.sale-live-container,.related-products').hide();
						$('.presale-container,.sale-module .module__text,.border-bottom:last').show();
					}

					displayTimerinfo("salenotstarted",modD);

				}
				aspotScenario(self);
			}
		});
	}, 1000);
}

function displayTimerinfo(value,element){
	if(value=="salestarted"){
		if($('.a-spot-regular')[0]){
			element.find(".timer-display").addClass('hide');
			element.find('.timer-container').show();
			if(window.innerWidth < 1024){
				element.find('.sale-starts.mobile-timer-info').show().find('.sale-date').hide();
			}
			else{
				element.find('.sale-starts.desktop-timer-info').show().find('.sale-date').hide();
			}
		}
	}
	else if(value=="salenotstarted"){
		if($('.a-spot-regular')[0]){
			element.find('.timer-container').show();
			if(window.innerWidth < 1024){
				element.find('.sale-date.mobile-timer-info').show().find('.sale-starts').hide();
        element.find('.sale-starts.mobile-timer-info.early-access').show();
			}
			else{
				element.find('.sale-date.desktop-timer-info').show().find('.sale-starts').hide();
        element.find('.sale-starts.desktop-timer-info.early-access').show();
			}
		}
	}
}

function timerShow(dateValue,element,self){

	var modD = self.parents('.sale-module');
	   // Update the count down every 1 second

		// Get today's date and time
		 now = new Date().getTime();

		// Find the distance between now and the count down date
		 distance = dateValue - now;

		// Time calculations for days, hours, minutes and seconds
		 days = Math.floor(distance / (1000 * 60 * 60 * 24));
		 hours = Math.floor(
			(distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
		);
		 minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
		 seconds = Math.floor((distance % (1000 * 60)) / 1000);

		// Output the result in an element with id="demo"
		element.find(".days").text(("0" + days).slice(-2));
		element.find(".hours").text(("0" + hours).slice(-2));
		element.find(".minutes").text(("0" + minutes).slice(-2));
		element.find(".seconds").text(("0" + seconds).slice(-2));
		//$("#countdown-container,.sale-starts").css("visibility","visible");
		$("#x").prop("checked", true);
		// If the count down is over, write some text
		if (distance < 0) {
			//$(".timer-placeholder,.hide-after-timer").hide();
			$("#days,#hours,#minutes,#seconds").text("00");
			clearInterval();
			if($('.template-product')[0] && $('.pdp-coming-soon')[0]){


					$('.coming-soon-badge').hide();
                    $('.pre-order-msg').remove();

                    if($('.comingsoon-preorder')[0]){
                      $('.product__payment-container.comingsoon-preorder').css('display','block');
                    }

                    if($('.comingsoon-upsell')[0]){
                    	$('.upsell-container.comingsoon-upsell').css('display','block');
                    	$('.tnc-container.comingsoon-upsell').addClass('showtnc');
                    }
                    $('.product__payment-container .comingsoonends').addClass('black-bg-cta').css('display','block');
                    if($('#signupNeeded').val()== 'false'){ //product available
                    	$('.pdp-soldout').remove();
                        $('.soldout-badge').remove();
                    }
                    else{
                        $('.soldout-badge').remove();
                    	var soldoutElem ='<span class="prd-inventory-tag color-gray addtitional-meta-fields medium soldout-badge" style="padding-left:0">Sold Out</span>';
                        $(soldoutElem).insertBefore('.product__meta .product__vendor');
						$('.product__add-to-cart').text("Sold Out"); // making text as soldout for soldout cases (js fixes for date caching issue)
                        $('.ship-available-date').closest('.grid').hide(); // hiding shipping info for soldout cases
                    }

			  	}
			modD.find('.sale--live').hide().find('.learn-more').hide().find('.timer-container').hide();
			modD.find('.shop-now-btn').show();
			/*Waiting Room */
            if($('.waiting-room')[0]){
                $('.sale-live-container,.related-products').show();
              $('.presale-container,.sale-module .module__text').hide();
            }

			$('.timer-display').css({'padding-right':'24px'});
            displayTimerinfo("salestarted",modD);

			//if($('.layoutWrap')[0]){
				var mainT = self.parents('.content-inside');
				if(mainT.find('.addtocartBtn').length > 0){
					mainT.find('.launching-info .sale-live-text').removeClass('hide');
					mainT.find('.launching-info  .lauching-date').addClass('hide');
					mainT.find('.addtocartBtn').removeClass('hide');
					mainT.find('.learnmoreBtn').addClass('hide');
				}
			//}
			modD.addClass('no-reload');
		}
		else if(days==0){

			$('.plp-button').show().css('margin-right','30px');
			$('.sale-live-container').hide();
            modD.find('.learn-more').show();
			modD.find('.timer-container').show();
			modD.find('.module__text').show();
			modD.find('.sale--live').show();
			displayTimerinfo("salenotstarted",modD);
		}
		else {

			var mainT = self.parents('.content-inside');
				if(mainT.find('.addtocartBtn').length > 0){
                  	mainT.find('.launching-info .sale-live-text').addClass('hide');
					mainT.find('.launching-info  .lauching-date').removeClass('hide');
					mainT.find('.addtocartBtn').addClass('hide');
					mainT.find('.learnmoreBtn').removeClass('hide');
				}

			modD.find('.sale--live').show();
			modD.find('.learn-more').show();
			modD.find('.timer-container').show();

			if($('.waiting-room')[0]){
				$('.sale-live-container,.related-products').hide();
				$('.presale-container,.sale-module .module__text,.border-bottom:last').show();
			}

			displayTimerinfo("salenotstarted",modD);
			if($('.template-product')[0]){
				$('.coming-soon-badge').css('opacity','1');
			}
		}
}

function timmerHandle(){
	$(".flex-grid-wrapper .image-content.desktop-none .timerDate").each(function(){
		var thisE = $(this);

		var parents = thisE.parents('.div-content');
		var timmerV = parents.find('.image-content.desktop-none .timmer-wrap .timerDate').val();


		if(timmerV != ''){

			var timmerHtml = parents.find('.image-content.desktop-none .timmer-wrap').html();
			sessionStorage.setItem("timmerHts", timmerHtml);
			var wsize = window.screen.width;
			var getTimeHt = sessionStorage.getItem("timmerHts");
			if(getTimeHt == null){
				sessionStorage.setItem("timmerHts", timmerHtml);
			}
			else{
				if(wsize > 1024){
					parents.find('.image-content.desktop-none .timmer-wrap').html('');
					parents.find('.image-content.mobile-none .timmer-wrap').html(getTimeHt);
					timmerS();
				}
				else{
					parents.find('.image-content.mobile-none .timmer-wrap').html('');
					parents.find('.image-content.desktop-none .timmer-wrap').html(getTimeHt);
					timmerS();
				}
			}
		}
	});
}

// custom timer logic for Raffle PDPs
function timerSDG() {
	const { raffleTimeSettings } = SDG.Data;

	if (raffleTimeSettings) {
		setInterval(function() {
			const currentTime = new Date().getTime();
			const startTimeRemaining = new Date(raffleTimeSettings.timerStartDate).getTime() - currentTime;
			const endTimeRemaining = new Date(raffleTimeSettings.timerEndDate).getTime() - currentTime;

			if (startTimeRemaining < 0 && endTimeRemaining > 0) {
				appendRaffleButton('active');
			} else if (startTimeRemaining < 0 && endTimeRemaining < 0) {
				appendRaffleButton('closed');
			} else {
				appendRaffleButton('presale');
			}
		}, 1000);
	}
}

// HTML Content for Raffle Button
function appendRaffleButton(state) {
	const { raffleTimeSettings } = SDG.Data;
	const $raffleContainer = document.getElementById('raffleContainer');
	const $soldOutBadge = document.querySelector('.soldout-badge');
	const $soldOutEmailSignUp = document.querySelector('.sold-out-subscription');
	const buttonState = $raffleContainer ? $raffleContainer.getAttribute('data-state') : null;
	$raffleContainer.setAttribute('data-state', state);
	if (state === buttonState) return;

	if ($soldOutEmailSignUp && state === 'closed') {
		__.removeClass($soldOutEmailSignUp, 'hide');
	}

	let $raffleButton = `
		<a
			class="product__add-to-cart button button--primary non-rlc-btn black-bg-cta raffle"
			href="${raffleTimeSettings.timerCtaHref}"
			data-state="${state}"
		>
			${raffleTimeSettings.timerCtaText}
		</a>
	`;

	if (state == 'presale') {
		$raffleButton = `
      <h6 class="pre-order-msg">
				${raffleTimeSettings.presaleLabel}
			</h6>
		`;
	} else if (state == 'closed') {
		$raffleButton = `
      <h6 class="pre-order-msg">
				${raffleTimeSettings.closedLabel}
			</h6>
		`;
	}

	if ($raffleContainer) {
		$raffleContainer.innerHTML = $raffleButton;
	}
}

$(window).resize(function(){
	timmerHandle();
})
